<div class="login-container">
  <div class="layerTop">
    <img src="../../../assets/images/layerTop.png" alt="" />
  </div>

  <div class="loginLogo mobile_logo">
    <span>
      <svg width="129" height="28" viewBox="0 0 129 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 18.5564H3.3473L3.34779 20.1685C3.87163 19.3103 4.90058 18.5564 6.4154 18.5564C7.70603 18.5564 8.60353 19.0699 9.07163 20.0477C9.91314 19.0014 11.0726 18.5564 12.3074 18.5564C14.1592 18.5564 15.506 19.6534 15.506 21.9028V27.9724H12.1602L12.1577 22.4167C12.1577 21.508 11.6716 21.0617 10.9046 21.0617C10.0069 21.0617 9.40804 21.5934 9.40804 22.5725L9.40779 27.978H6.09992L6.09749 22.4167C6.09749 21.508 5.61186 21.0617 4.84411 21.0617C3.9471 21.0617 3.34779 21.5934 3.34779 22.5725L3.3473 27.978H0V18.5564Z"
          fill="#DA2129"
        />
        <path
          d="M16.6492 23.3899V23.2534C16.6492 20.3703 18.9875 18.5515 22.0171 18.5515C25.0292 18.5515 27.3481 20.3175 27.3481 23.1678V23.3041C27.3481 26.2229 25.0097 27.9724 21.9988 27.9724C18.9875 27.9724 16.6492 26.2918 16.6492 23.3899ZM23.9433 23.3388V23.202C23.9433 21.6924 23.2897 20.8504 22.0171 20.8504C20.764 20.8504 20.0722 21.6577 20.0722 23.1678V23.3041C20.0722 24.8495 20.7267 25.6907 22.0171 25.6907C23.271 25.6907 23.9433 24.8317 23.9433 23.3388Z"
          fill="#DA2129"
        />
        <path
          d="M32.1745 24.5914V20.885H34.1012V18.7921H32.1745V18.3896V16.9203V16.5176L28.826 17.7579V18.1606V18.3896V18.7921H27.6473V20.885H28.826V24.8837C28.826 26.9942 30.0601 27.9723 32.268 27.9723C33.0535 27.9723 33.6888 27.8184 34.1194 27.7143V25.3821C33.8196 25.4851 33.5394 25.5367 33.165 25.5367C32.5294 25.5367 32.1745 25.2442 32.1745 24.5914Z"
          fill="#DA2129"
        />
        <path
          d="M42.0394 18.5564C40.4121 18.5564 39.3456 19.3103 38.8218 20.2377V15.9662L38.822 14.0945L35.4738 15.3348V15.7497V15.9662V27.978H38.8223L38.8218 22.7435C38.8218 21.5934 39.4958 21.045 40.4871 21.045C41.4591 21.045 41.8894 21.5421 41.8894 22.5539L41.8877 27.978L45.2377 27.9773V21.9373C45.2377 19.6363 43.9283 18.5564 42.0394 18.5564Z"
          fill="#DA2129"
        />
        <path
          d="M46.3591 23.3946V23.2583C46.3591 20.3752 48.6969 18.5564 51.6523 18.5564C54.3271 18.5564 56.6291 19.9624 56.6291 23.1898V23.996H49.7441C49.8391 25.18 50.5866 25.8672 51.784 25.8672C52.8872 25.8672 53.3551 25.4045 53.4863 24.8026H56.6291C56.329 26.8278 54.6264 27.9773 51.6711 27.9773C48.6035 27.9773 46.3591 26.331 46.3591 23.3946ZM53.3738 22.2631C53.3173 21.1813 52.7378 20.5809 51.6523 20.5809C50.6421 20.5809 49.9508 21.1813 49.7819 22.2631H53.3738Z"
          fill="#DA2129"
        />
        <path
          d="M57.905 18.5561H61.2555L61.2538 20.4602C61.8709 19.1214 62.8989 18.5376 64.4146 18.5563V21.4217C62.3755 21.371 61.2538 21.9534 61.2538 23.3945L61.2528 27.9777H57.905V18.5561Z"
          fill="#DA2129"
        />
        <path
          d="M64.9412 24.9232H68.0274C68.1403 25.5755 68.4575 25.9357 69.412 25.9357C70.2347 25.9357 70.6086 25.644 70.6086 25.1983C70.6086 24.7681 70.141 24.5624 68.7939 24.3912C66.1759 24.0821 65.0717 23.3782 65.0717 21.508C65.0717 19.5157 66.9991 18.5564 69.2627 18.5564C71.6748 18.5564 73.3578 19.3103 73.5833 21.4569H70.5521C70.4214 20.8553 70.067 20.564 69.2995 20.564C68.5699 20.564 68.1955 20.8553 68.1955 21.2669C68.1955 21.6971 68.6449 21.8686 69.8419 22.0053C72.5543 22.3144 73.8634 22.9663 73.8634 24.8889C73.8634 27.0161 72.1428 27.9773 69.4301 27.9773C66.6433 27.9773 65.0157 26.9127 64.9412 24.9232Z"
          fill="#DA2129"
        />
        <path
          d="M74.4711 23.3946V23.2583C74.4711 20.3752 76.8088 18.5564 79.8396 18.5564C82.8511 18.5564 85.1697 20.3224 85.1697 23.1725V23.309C85.1697 26.2278 82.8321 27.9773 79.8207 27.9773C76.8088 27.9773 74.4711 26.2967 74.4711 23.3946ZM81.7659 23.3437V23.2069C81.7659 21.6971 81.1115 20.8553 79.8396 20.8553C78.5861 20.8553 77.895 21.6626 77.895 23.1725V23.309C77.895 24.8542 78.5491 25.6956 79.8396 25.6956C81.0927 25.6956 81.7659 24.8364 81.7659 23.3437Z"
          fill="#DA2129"
        />
        <path
          d="M86.3618 18.5564H89.6943L89.7101 20.2377C90.2337 19.3103 91.2997 18.5564 92.9274 18.5564C94.8166 18.5564 96.1262 19.6363 96.1262 21.9373V27.9764H92.7743L92.7783 22.5539C92.7783 21.5421 92.3474 21.045 91.3745 21.045C90.3839 21.045 89.7101 21.5934 89.7101 22.7434L89.7023 27.9773H86.3618V18.5564Z"
          fill="#DA2129"
        />
        <path
          d="M123.062 1.96018C121.791 2.49496 120.899 3.71019 120.883 5.12808L120.883 28H125.967C127.172 28 128.147 27.0601 128.147 25.8998V0L123.062 1.96018Z"
          fill="#DA2129"
        />
        <path
          d="M113.618 8.95994C112.348 9.4952 111.455 10.7102 111.439 12.1278L111.438 27.9999H116.524C117.727 27.9999 118.703 27.0601 118.703 25.8997V7L113.618 8.95994Z"
          fill="#DA2129"
        />
        <path
          d="M104.174 15.9599C102.903 16.495 102.011 17.7104 101.995 19.1276L101.994 27.9999H107.08C108.283 27.9999 109.259 27.06 109.259 25.8997V14L104.174 15.9599Z"
          fill="#DA2129"
        />
      </svg>
    </span>
  </div>

  <div class="overlayDrop" *ngIf="connectionFailedPopupActive" (click)="closeconnectionFailedPopup($event)"></div>

  <div
    class="connection-failed-panel"
    *ngIf="connectionFailedPopupActive"
    [ngClass]="{ 'layout-rightpanel-active': connectionFailedPopupActive }"
  >
    <div class="connection-failed-popup">
      <div class="flex">
        <div class="hazard-icon">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M22.23 18L14.23 4C14.0556 3.69221 13.8026 3.43619 13.4969 3.25807C13.1912 3.07995 12.8438 2.98611 12.49 2.98611C12.1362 2.98611 11.7887 3.07995 11.4831 3.25807C11.1774 3.43619 10.9244 3.69221 10.75 4L2.74999 18C2.57367 18.3054 2.48122 18.6519 2.482 19.0045C2.48278 19.3571 2.57677 19.7033 2.75444 20.0078C2.93211 20.3124 3.18714 20.5646 3.49369 20.7388C3.80023 20.9131 4.1474 21.0032 4.49999 21H20.5C20.8509 20.9996 21.1955 20.907 21.4993 20.7313C21.803 20.5556 22.0552 20.3031 22.2305 19.9991C22.4058 19.6951 22.498 19.3504 22.4979 18.9995C22.4978 18.6486 22.4054 18.3039 22.23 18Z"
              stroke="#6D1014"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M12.5 9V13" stroke="#6D1014" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.5 17H12.51" stroke="#6D1014" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div>
          <h3>Failed to call UniBuild API's - How to fix ?</h3>
          <!-- <p class="para">The management level selection dropdown options are currently unavailable since your network is preventing access.</p> -->
          <p class="para"></p>

          <!-- <h4>How to fix it ?</h4> -->
          <p>Reach out to your local IT department and request them to allow access to 'https://*.unibuild.ai/*' on your network.</p>
        </div>
        <div class="close-icon" (click)="closeconnectionFailedPopup($event)">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.5 6L6.5 18" stroke="#666666" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.5 6L18.5 18" stroke="#666666" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="action-button">
        <button mat-button class="confirm-connection-failed" (click)="closeconnectionFailedPopup($event)">Ok, got it</button>
      </div>
    </div>
  </div>

  <div class="loginWrapp">
    <div class="loginForm">
      <div class="formWrapp">
        <h2 class="text-center">Register as a Customer</h2> 
        <div class="formFeilds wrappInside">
          <form #regForm="ngForm" [formGroup]="registerForm" (ngSubmit)="register()" (keydown.enter)="$event.preventDefault()">
            <div class="stepperWrapp">
              <div class="formGroup">
                <label>Company <sup>*</sup></label>
                <mat-form-field appearance="outline">
                  <input maxlength="200" matInput formControlName="company" placeholder="Enter your company name" />
                </mat-form-field>
                <div class="errorTxt">
                  <div *ngIf="registerForm?.get('company')?.touched || registerForm?.get('company')?.dirty">
                    <div *ngIf="registerForm?.get('company')?.hasError('required')">Company is required</div>
                  </div>
                </div>
              </div>
              <div class="formGroup">
                <label>Title <sup>*</sup></label>
                <mat-form-field appearance="outline">
                  <mat-select formControlName="title" placeholder="Select your title">
                    <!-- <mat-option>Enter your Title</mat-option> -->
                    <mat-option value="Mr.">Mr.</mat-option>
                    <mat-option value="Mrs.">Mrs.</mat-option>
                    <mat-option value="Dr.">Dr.</mat-option>
                    <mat-option value="Miss">Miss</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="formGroup">
                <label>First Name <sup>*</sup></label>
                <mat-form-field appearance="outline">
                  <input maxlength="100" matInput formControlName="name" placeholder="Enter your first name" />
                </mat-form-field>
                <div class="errorTxt">
                  <div *ngIf="registerForm?.get('name')?.touched || registerForm?.get('name')?.dirty">
                    <div *ngIf="registerForm?.get('name')?.hasError('required')">First name is required</div>
                    <div *ngIf="registerForm?.get('name')?.hasError('minlength')">First Name must be at least 4 characters long</div>
                  </div>
                </div>
              </div>
              <div class="formGroup">
                <label>Last Name <sup>*</sup></label>
                <mat-form-field appearance="outline">
                  <input maxlength="100" matInput formControlName="lastName" placeholder="Enter your last name" />
                </mat-form-field>
                <div class="errorTxt">
                  <div *ngIf="registerForm?.get('lastName')?.hasError('required') && registerForm?.get('lastName')?.touched">
                    Lastname is required
                  </div>
                  <div *ngIf="registerForm?.get('lastName')?.hasError('minlength') && registerForm?.get('lastName')?.touched">
                    Lastname must be at least 4 characters long
                  </div>
                </div>
              </div>
              <div class="formGroup">
                <label>Work email <sup>*</sup></label>
                <mat-form-field appearance="outline">
                  <input
                    maxlength="200"
                    matInput
                    formControlName="companyEmail"
                    (blur)="isAlreadyExists()"
                    placeholder="Enter your work email"
                  />
                </mat-form-field>
                <div class="errorTxt">
                  <div *ngIf="registerForm?.get('companyEmail')?.touched || registerForm?.get('companyEmail')?.dirty">
                    <div *ngIf="registerForm?.get('companyEmail')?.hasError('required')">Email is required</div>
                    <div
                      *ngIf="
                        registerForm?.get('companyEmail')?.value != '' &&
                        (registerForm?.get('companyEmail')?.hasError('email') ||
                          registerForm.get('companyEmail')?.hasError('numericAfterDotCom'))
                      "
                    >
                      Must be a valid email address
                    </div>
                    <div
                      *ngIf="
                        userExist &&
                        registerForm?.get('companyEmail')?.value != '' &&
                        !registerForm?.get('companyEmail')?.hasError('email') &&
                        !registerForm.get('companyEmail')?.hasError('numericAfterDotCom')
                      "
                    >
                      Email already exist.
                    </div>
                  </div>
                </div>
              </div>
              <div class="formGroup">
                <label>Mobile No. <sup>*</sup></label>
                <div class="mobileItem d-flex">
                  <ngx-intl-tel-input
                    [cssClass]="'custom'"
                    [preferredCountries]="preferredCountries"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="CountryISO.India"
                    [maxLength]="15"
                    [enablePlaceholder]="true"
                    customPlaceholder="Enter mobile number"
                    [phoneValidation]="true"
                    [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.National"
                    formControlName="mobile"
                  >
                  </ngx-intl-tel-input>
                </div>
                <div class="errorTxt">
                  <div *ngIf="registerForm?.get('mobile')?.touched || registerForm?.get('mobile')?.dirty">
                    {{ isPhoneValid(registerForm.controls["mobile"].errors) }}
                  </div>
                  <div *ngIf="registerForm?.get('mobile')?.touched">
                    {{ isPhoneRequired(regForm.form.value.mobile) }}
                  </div>
                </div>
              </div>

              <div class="formGroup">
                <label>Functional Department <sup>*</sup></label>
                <mat-form-field appearance="outline">
                  <mat-select
                    id="modules_registration_module_registrationform_7"
                    formControlName="department"
                    placeholder="Select functional department"
                  >
                    <mat-option>Select Department</mat-option>
                    <mat-option *ngFor="let data of departments" [value]="[data.functionalDepartmentId, data.functionalDepartmentName]"
                      >{{ data.functionalDepartmentName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="formGroup" *ngIf="checkFieldValue('department')">
                <label>Others <sup>*</sup></label>
                <mat-form-field appearance="outline">
                  <input maxlength="200" matInput id="others" formControlName="departmentOthers" placeholder="Others" />
                </mat-form-field>
                <div class="errorTxt">
                  <div *ngIf="registerForm?.get('departmentOthers')?.touched || registerForm?.get('departmentOthers')?.dirty">
                    <div *ngIf="registerForm?.get('departmentOthers')?.hasError('required')">Others is required</div>
                  </div>
                </div>
              </div>
              <!-- <label class="medium">Your Interests <sup>*</sup></label>
              <div class="popupDropdown">
                <div class="alignCenter flex" *ngIf="!interestData.length || interestData.length < 1">
                  <span class="iconCenter"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      (click)="openDialog()"
                      class="badge-notfication"
                      height="24"
                      viewBox="0 -960 960 960"
                      width="24"
                    >
                      <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" /></svg
                  ></span>
                  <span class="placeholderText">Enter your interest</span>
                </div>
                <div class="chipIcon">
                  <ng-container *ngFor="let interestChip of interestData">
                    <mat-chip *ngIf="interestChip.interestValues?.length > 0">
                      {{ interestChip.name }} ({{ interestChip.interestValues?.length }})
                    </mat-chip>
                  </ng-container>
                </div>
                <div class="dialogEdit" *ngIf="interestData.length > 0" (click)="openDialog()">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" class="badge-notfication" width="24">
                    <path
                      d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
                    />
                  </svg>
                </div>
              </div> -->
              <!-- <div *ngIf="interestValidation" class="errorTxt">*Please select at least one interest from each category</div> -->
              <!-- <button mat-button class="btnCustom btnGray" >Update Profile</button> -->
      
              <div class="formGroup">
                <label>How did you hear about us?<sup></sup></label>
                <mat-form-field appearance="outline">
                  <mat-select
                    id="module_registrationmodule_registrationform_1001"
                    formControlName="sourceManagement"
                    placeholder="Select How did you hear about us"
                  >
                    <mat-option>Select How did you hear about us</mat-option>
                    <mat-option *ngFor="let data of sourceManagement" [value]="[data.sourceId, data.source]">{{ data.source }} </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="formGroup" *ngIf="checkFieldValue('sourceManagement')">
                <label>Others</label>
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    maxlength="200"
                    id="others"
                    formControlName="sourceManagementOthers"
                    placeholder="Others"
                    id="module_registrationmodule_registrationform_1002"
                  />
                </mat-form-field>
              </div>
              
              <div class="formGroup checkboxItem signUp">
                <mat-checkbox class="example-margin" formControlName="termsAndConditions">I agree to </mat-checkbox>
                <span class="termCondition cursor" (click)="getTermsAndConditions()"> Terms and Conditions.</span>
              </div>

              <div class="formGroup mt-24">
                <button
                  id="modules_registration_module_registrationform_11"
                  mat-button
                  color="primary"
                  class="primaryButton"
                  [disabled]="isValid()"
                >
                  Register
                </button>
              </div>
              <div class="signupLink">Already have an account? <a routerLink="/prelogin">Sign In</a></div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
